export var MOBILE_BREAKDOWN = 767;
export var DEFAULT_SLIDER_DELAY = 4000;
export var DEFAULT_SLIDER_PAGINATION_TYPE = "bullets";
export var DEFAULT_SLIDER_EFFECT = "slide";
export var DEFAULT_SLIDER_SPEED = "300";
export var MSD_SPECIALTIES_OPTIONS = [
    { value: "Allergy", label: "Allergy" },
    { value: "Anesthesiology", label: "Anesthesiology" },
    { value: "Audiology", label: "Audiology" },
    { value: "Cardiology", label: "Cardiology" },
    { value: "Cardio-thoraric surgery", label: "Cardio-thoraric surgery" },
    { value: "Clinical Microbiologist", label: "Clinical Microbiologist" },
    { value: "Clinical Oncology", label: "Clinical Oncology" },
    { value: "Clinical Pharmacology", label: "Clinical Pharmacology" },
    { value: "Clinical Research", label: "Clinical Research" },
    { value: "Dentistry", label: "Dentistry" },
    { value: "Dermato-oncology", label: "Dermato-oncology" },
    { value: "Endocrinology", label: "Endocrinology" },
    { value: "Epidemiology", label: "Epidemiology" },
    { value: "Gastro-endoscopy", label: "Gastro-endoscopy" },
    { value: "Gastroenterology", label: "Gastroenterology" },
    { value: "General Practitioner/Family Physician/Primary Care", label: "General Practitioner/Family Physician/Primary Care" },
    { value: "Geriatrics", label: "Geriatrics" },
    { value: "Gynecology", label: "Gynecology" },
    { value: "Hematology", label: "Hematology" },
    { value: "Hepatology", label: "Hepatology" },
    { value: "Immunology", label: "Immunology" },
    { value: "Infectious Disease", label: "Infectious Disease" },
    { value: "Intensive Care/Critical Care", label: "Intensive Care/Critical Care" },
    { value: "Internal Medicine", label: "Internal Medicine" },
    { value: "Mastology", label: "Mastology" },
    { value: "Medical Oncology", label: "Medical Oncology" },
    { value: "Medical Student/ Resident", label: "Medical Student/ Resident" },
    { value: "Microbiologist", label: "Microbiologist" },
    { value: "Neonatology", label: "Neonatology" },
    { value: "Nephrology", label: "Nephrology" },
    { value: "Neurology", label: "Neurology" },
    { value: "Nurse", label: "Nurse" },
    { value: "Nurse Practitioner", label: "Nurse Practitioner" },
    { value: "Nutritionist", label: "Nutritionist" },
    { value: "Onco-Hematology", label: "Onco-Hematology" },
    { value: "Oncology", label: "Oncology" },
    { value: "Ophthalmology", label: "Ophthalmology" },
    { value: "Orthopedics", label: "Orthopedics" },
    { value: "Otolaryngology / ENT Surgery", label: "Otolaryngology / ENT Surgery" },
    { value: "Pathology", label: "Pathology" },
    { value: "Pediatric Infectious Disease", label: "Pediatric Infectious Disease" },
    { value: "Pediatrics", label: "Pediatrics" },
    { value: "Pharmacology", label: "Pharmacology" },
    { value: "Pharmacy", label: "Pharmacy" },
    { value: "Physical & Occupational Therapy", label: "Physical & Occupational Therapy" },
    { value: "Physician Assistant", label: "Physician Assistant" },
    { value: "Psychiatry", label: "Psychiatry" },
    { value: "Public Health Specialty", label: "Public Health Specialty" },
    { value: "Pulmonology/Respiratory", label: "Pulmonology/Respiratory" },
    { value: "Radiation Oncology", label: "Radiation Oncology" },
    { value: "Radiology", label: "Radiology" },
    { value: "Rheumatology", label: "Rheumatology" },
    { value: "Surgery", label: "Surgery" },
    { value: "Thoracic Surgery", label: "Thoracic Surgery" },
    { value: "Transplant Surgery", label: "Transplant Surgery" },
    { value: "Urology", label: "Urology" },
    { value: "Vaccinology", label: "Vaccinology" },
    { value: "Virology", label: "Virology" }
];
export var VOD_QUIZ_MODAL_TIME_OFFSET = 10;
export var VOD_NOT_ALLOWED_FALLBACK = "Sorry but you are not allowed to watch the VOD again";
/** The W3C `TextTrackKind` values evejs-react-player / video.js accept for a side-loaded text track; any other value is coerced to "subtitles". */
export var PLAYER_VALID_TEXT_TRACK_KINDS = ["subtitles", "captions", "descriptions", "chapters", "metadata"];
